<form *ngIf="renewalForm" [formGroup]="renewalForm">
  <div class="row">


    <div class="col-sm-12 col-md-6">
      <div class="entradas-de-texto-govco">
        <label for="depaId">Departamento <span class="required">*</span></label>
        <select class="form-select" id="depaId" aria-label="Default select example"
                formControlName="renovationDepartmentId" [ngClass]="{'error': isTouchedField(renewalForm, 'renovationDepartmentId')}"
        >
          <option value="" disabled selected>Seleccione</option>
          <option [value]="bogotaDepartamento.idDepartamento">{{ bogotaDepartamento.descripcion }}</option>
        </select>
        <span *ngIf="!isValidField(renewalForm, 'renovationDepartmentId')"
              class="error-texto-govco alert-entradas-de-texto-govco" id="departamento-note" role="alert"
              aria-live="assertive">
                  {{ getErrorMessage('renovationDepartmentId') }}
          </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-6">
      <div class="entradas-de-texto-govco">
        <label for="munId">Municipio <span class="required">*</span></label>
        <select class="form-select" id="munId" aria-label="Default select example"
                formControlName="renovationMunicipalityId" [ngClass]="{'error': isTouchedField(renewalForm, 'renovationMunicipalityId')}"
        >
          <option value="" disabled selected>Seleccione</option>
          <option *ngFor="let municipio of municipios"
                  [value]="municipio.idMunicipio">{{ municipio.descripcion }}</option>
        </select>
        <span *ngIf="!isValidField(renewalForm, 'renovationMunicipalityId')"
              class="error-texto-govco alert-entradas-de-texto-govco" id="municipio-note" role="alert"
              aria-live="assertive">
                  {{ getErrorMessage('renovationMunicipalityId') }}
          </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-12 mt-4">
      <label for="inptFileLicAnterior" class="label-carga-de-archivo-govco">PDF Licencia Anterior
        <span class="required">*</span></label>
      <div class="input-group mt-2 mb-1">
        <input type="file" class="form-control input-file-custom" id="inptFileLicAnterior"
               aria-describedby="inptFileLicAnterior" aria-label="Upload"
               formControlName="file"
               [ngClass]="{'error': !isCorrectField(renewalForm, 'licenciaAnteriorFile')}"
               accept="application/pdf" (change)="checkSelectedFile($event)">
     </div>
      <span class="text-validation-carga-de-archivo-govco"><small>Únicamente archivo(s) en formato .pdf.</small></span>
      <br>
    </div>


    <div class="col-sm-12 col-md-6">
      <div class="entradas-de-texto-govco">
        <label for="input-basico-id">Número de resolución de la licencia anterior<span class="required">*</span></label>
        <input type="text" id="input-basico-id" placeholder="Número de resolución de la licencia anterior"
               formControlName="resolutionToModify"
               [ngClass]="{'error': isTouchedField(renewalForm, 'resolutionToModify')}"
        />
        <span *ngIf="!isValidField(renewalForm, 'resolutionToModify')"
              class="error-texto-govco alert-entradas-de-texto-govco" id="number-note" role="alert"
              aria-live="assertive">
          {{ getErrorMessage('resolutionToModify') }}
        </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-6">
      <div class="entradas-de-texto-govco">
        <label for="fecha-resolucion-licencia-anterior">Fecha de resolución de la licencia anterior <span class="required">*</span></label>
        <input type="date" id="fecha-resolucion-licencia-anterior"
               placeholder="Fecha de resolución de la licencia anterior"
               formControlName="dateResolutionToModify"
               (click)="verificarFecha()"
               [ngClass]="{'error': isTouchedField(renewalForm, 'dateResolutionToModify')}"
        />
        <span *ngIf="!isValidField(renewalForm, 'dateResolutionToModify')"
              class="error-texto-govco alert-entradas-de-texto-govco" id="fecha-resolucion-note" role="alert"
              aria-live="assertive">
          {{ getErrorMessage('dateResolutionToModify') }}
        </span>
      </div>
    </div>

  </div>
</form>
